(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessory-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class AccessoryHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.accessory-hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-button]'));
      this.index = 0;
      this.timer = null;
      this.interval = Number(this.dataset.interval || 5500);
      this.shouldAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.slideButton || 0));
          this.restart();
        });
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.start();
          } else {
            this.stop();
          }
        });
      }, { threshold: 0.35 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
    }

    start() {
      if (!this.shouldAutoplay || this.reducedMotion || this.timer) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    next() {
      this.goTo((this.index + 1) % this.slides.length);
    }

    goTo(nextIndex) {
      if (!this.slides.length || nextIndex === this.index) return;
      const safeIndex = Math.max(0, Math.min(this.slides.length - 1, nextIndex));
      this.slides[this.index]?.classList.remove('accessory-hero-slider__slide--active');
      this.dots[this.index]?.classList.remove('accessory-hero-slider__dot--active');
      this.index = safeIndex;
      this.slides[this.index]?.classList.add('accessory-hero-slider__slide--active');
      this.dots[this.index]?.classList.add('accessory-hero-slider__dot--active');
    }
  }

  if (!customElements.get('accessory-hero-slider')) {
    customElements.define('accessory-hero-slider', AccessoryHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-product-showcase"] && !Shopify.designMode) return;
  try {
    
  class ParallaxShowcaseComponent extends HTMLElement {
    connectedCallback() {
      // PC: image-wrap 要素と text ブロックを収集
      this._imageWraps = Array.from(this.querySelectorAll('.parallax-showcase__image-wrap'));
      this._textInners = Array.from(this.querySelectorAll('.parallax-showcase__text-inner'));
      this._texts      = Array.from(this.querySelectorAll('.parallax-showcase__text'));
      this._blockCount = parseInt((this.style.getPropertyValue('--block-count') || '').trim()) || this._texts.length;
      this._carousel   = this.querySelector('.parallax-showcase__carousel');
      this._mobileDots = Array.from(this.querySelectorAll('.parallax-showcase__mobile-dot'));

      // ブロックindex → 対応 imageWrap のマップ
      // 画像なしブロックは直前に画像があった wrap を継続使用
      this._imgWrapForBlock = this._buildImgMap();

      // 初期表示：最初の image-wrap を表示
      this._activeWrap = this._imageWraps[0] || null;
      if (this._activeWrap) this._activeWrap.style.opacity = '1';

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // テキストフェードイン（PCテキストのみ）
      if (!reduced && this._textInners.length) {
        this._textObserver = new IntersectionObserver(
          (entries) => entries.forEach(e => e.target.classList.toggle('is-visible', e.isIntersecting)),
          { threshold: 0.15 }
        );
        this._textInners.forEach(el => this._textObserver.observe(el));
      } else {
        this._textInners.forEach(el => el.classList.add('is-visible'));
      }

      // 画像切り替え：RAF で毎フレームポーリング
      // SPではimage-colが非表示なので実質無害（getBCRは0を返すだけ）
      this._rafId = null;
      if (!reduced) {
        this._startRaf();
      }

      this._scrollIndicatorRaf = null;
      this._handleCarouselScroll = () => {
        if (this._scrollIndicatorRaf) return;
        this._scrollIndicatorRaf = requestAnimationFrame(() => {
          this._scrollIndicatorRaf = null;
          this._updateMobileIndicator();
        });
      };

      if (this._carousel && this._mobileDots.length) {
        this._carousel.addEventListener('scroll', this._handleCarouselScroll, { passive: true });
        this._updateMobileIndicator();
      }
    }

    disconnectedCallback() {
      this._stopRaf();
      if (this._textObserver) this._textObserver.disconnect();
      if (this._carousel && this._handleCarouselScroll) {
        this._carousel.removeEventListener('scroll', this._handleCarouselScroll);
      }
      if (this._scrollIndicatorRaf) {
        cancelAnimationFrame(this._scrollIndicatorRaf);
        this._scrollIndicatorRaf = null;
      }
    }

    // ブロックindex → imageWrap マップを構築
    _buildImgMap() {
      const sorted = [...this._imageWraps].sort(
        (a, b) => parseInt(a.dataset.image) - parseInt(b.dataset.image)
      );
      const map = [];
      let last = sorted[0] || null;
      for (let i = 0; i < this._blockCount; i++) {
        const w = sorted.find(w => parseInt(w.dataset.image) === i);
        if (w) last = w;
        map[i] = last;
      }
      return map;
    }

    _startRaf() {
      const tick = () => {
        this._updateImage();
        this._rafId = requestAnimationFrame(tick);
      };
      this._rafId = requestAnimationFrame(tick);
    }

    _stopRaf() {
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }

    // ビューポート中央に最も近いテキストブロックの画像に切り替え
    _updateImage() {
      if (!this._texts.length || !this._imageWraps.length) return;

      const mid = (window.innerHeight || document.documentElement.clientHeight) * 0.5;
      let minDist = Infinity;
      let activeIdx = 0;

      this._texts.forEach((el, i) => {
        const r    = el.getBoundingClientRect();
        const cy   = r.top + r.height * 0.5;
        const dist = Math.abs(cy - mid);
        if (dist < minDist) { minDist = dist; activeIdx = i; }
      });

      const target = this._imgWrapForBlock[activeIdx];
      if (!target || target === this._activeWrap) return;

      // クロスフェード
      if (this._activeWrap) this._activeWrap.style.opacity = '0';
      target.style.opacity = '1';
      this._activeWrap = target;
    }

    _updateMobileIndicator() {
      if (!this._carousel || !this._mobileDots.length) return;

      const slideWidth = this._carousel.clientWidth || 1;
      const activeIndex = Math.max(
        0,
        Math.min(this._mobileDots.length - 1, Math.round(this._carousel.scrollLeft / slideWidth))
      );

      this._mobileDots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }
  }

  if (!customElements.get('parallax-showcase-component')) {
    customElements.define('parallax-showcase-component', ParallaxShowcaseComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
